export default __webpack_public_path__ + "static/media/132.0243f52e.png";